import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useForm, Controller }                 from 'react-hook-form';
import Select                                  from 'react-select';

// Opções provisórias — devem vir da API (turnos cadastrados) quando o backend existir.
const turnoOptions = [
    { value: 'manha', label: 'Manhã (06h-14h)' },
    { value: 'tarde', label: 'Tarde (14h-22h)' },
    { value: 'noite', label: 'Noite (22h-06h)' },
]

function ShiftChangeForm({ isOpen, onClose, onSubmit, isSubmitting }) {

    const { control, register, handleSubmit, reset, formState: { errors } } = useForm({
        defaultValues: {
            responsibleUser: '',
            responsibleTurno: null,
            receivingUser: '',
            receivingTurno: null,
        }
    })

    const handleClose = () => {
        reset()
        onClose()
    }

    return (

        <Dialog open={isOpen} onClose={handleClose} className="relative z-[100]">

            <DialogBackdrop
                transition
                className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">

                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

                    <DialogPanel
                        transition
                        className="w-[600px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >

                        <div className="app-container">

                            <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                                <h2 className="text-white text-[1rem] leading-7 font-semibold">Novo Turno</h2>
                                <button onClick={handleClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2">×</button>
                            </header>

                            <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4 flex flex-col gap-5">

                                <div className="flex flex-col gap-[10px]">

                                    <span className="text-sm font-semibold text-azul-profundo-m uppercase tracking-wide border-b border-b-[#e3e2e2] pb-1.5">
                                        Responsável pelo Turno
                                    </span>

                                    <div className="flex gap-3">

                                        <div className="flex flex-col flex-1">
                                            <span className="text-sm font-semibold">Usuário responsável:</span>
                                            <input
                                                type="text"
                                                placeholder="Digite o nome do usuário"
                                                className={`rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 ${errors?.responsibleUser ? 'border border-red-300' : 'border border-gray-300'}`}
                                                {...register('responsibleUser', { required: true })}
                                            />
                                        </div>

                                        <div className="flex flex-col w-[190px] shrink-0">
                                            <span className="text-sm font-semibold">Turno:</span>
                                            <Controller
                                                control={control}
                                                name="responsibleTurno"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        inputId="responsibleTurno"
                                                        placeholder="Turno ..."
                                                        isSearchable={false}
                                                        options={turnoOptions}
                                                        classNamePrefix="select"
                                                    />
                                                )}
                                            />
                                        </div>

                                    </div>

                                </div>

                                <div className="flex flex-col gap-[10px]">

                                    <span className="text-sm font-semibold text-azul-profundo-m uppercase tracking-wide border-b border-b-[#e3e2e2] pb-1.5">
                                        Passar de turno para
                                    </span>

                                    <div className="flex gap-3">

                                        <div className="flex flex-col flex-1">
                                            <span className="text-sm font-semibold">Usuário que receberá o turno:</span>
                                            <input
                                                type="text"
                                                placeholder="Digite o nome do usuário"
                                                className={`rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 ${errors?.receivingUser ? 'border border-red-300' : 'border border-gray-300'}`}
                                                {...register('receivingUser', { required: true })}
                                            />
                                        </div>

                                        <div className="flex flex-col w-[190px] shrink-0">
                                            <span className="text-sm font-semibold">Turno:</span>
                                            <Controller
                                                control={control}
                                                name="receivingTurno"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        inputId="receivingTurno"
                                                        placeholder="Turno ..."
                                                        isSearchable={false}
                                                        options={turnoOptions}
                                                        classNamePrefix="select"
                                                    />
                                                )}
                                            />
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <footer className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    onClick={handleSubmit(onSubmit)}
                                    className="btn btn-azul-prof sm:ml-3 w-[100%] text-[1.125rem] disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    {isSubmitting ? 'Passando Turno...' : 'Passar Turno'}
                                </button>
                            </footer>

                        </div>

                    </DialogPanel>

                </div>

            </div>

        </Dialog>

    )
}

export default ShiftChangeForm;
